/** 총 생산 막대 라벨: 막대 안에 "총 생산" + 숫자 두 줄 (품질 이력 분석 TotalLabelOnTopSegment와 동일한 역할)
 *  분기: 그래프 높이 충분 → 막대 안에 표시 / 그래프 높이 낮음 → 막대 바깥에 표시 */
const MIN_BAR_HEIGHT_FOR_INSIDE_LABEL_PX = 28;
const MIN_CHART_HEIGHT_FOR_INSIDE_LABEL_PX = 280; // 이 값 이상이면 그래프가 충분히 높은 것으로 보고 라벨을 막대 안에 표시
const COUNT_LABEL_OUTSIDE_OFFSET_PX = 4;

export default function TotalLabelOnTopSegment({ x, y, width, height, value, chartHeight = 0 }) {
    const n = Number(value);
    if (n == null || isNaN(n)) return null;
    const isChartTallEnough = chartHeight >= MIN_CHART_HEIGHT_FOR_INSIDE_LABEL_PX;
    const isBarTallEnough = height >= MIN_BAR_HEIGHT_FOR_INSIDE_LABEL_PX;
    const showInside = isChartTallEnough ? true : isBarTallEnough;
    const cx = x + width / 2;
    const labelFill = showInside ? '#FFF' : '#0A2B83';
    const fontSize = 12;
    const lineHeight = 14;
    const yPos = y + height / 2;
    if (showInside) {
        // 막대 안쪽에 표시할 때는 반투명 흰색 박스로 "총 생산" 라벨을 감싸서 가독성 확보
        const boxW = 50;
        const boxH = 32;
        const boxX = cx - boxW / 2;
        const boxY =  yPos - 20
        return (
            <g>
                <rect
                    x={boxX}
                    y={boxY}
                    width={boxW}
                    height={boxH}
                    rx={4}
                    ry={4}
                    fill="rgba(255,255,255,0.7)"
                />
                <text
                    x={cx}
                    y={y + height / 2 - lineHeight / 2}
                    textAnchor="middle"
                    fill={labelFill}
                    fontSize={fontSize}
                    fontFamily="NanumSquare"
                >
                    총 생산
                </text>
                <text
                    x={cx}
                    y={y + height / 2 + lineHeight / 2}
                    textAnchor="middle"
                    fill={labelFill}
                    fontSize={fontSize}
                    fontFamily="NanumSquare"
                >
                    {n.toLocaleString()}
                </text>
            </g>
        );
    }
    return (
        <g>
            <text x={cx} y={y - COUNT_LABEL_OUTSIDE_OFFSET_PX - lineHeight} textAnchor="middle" fill={labelFill} fontSize={fontSize} fontFamily="NanumSquare">총 생산</text>
            <text x={cx} y={y - COUNT_LABEL_OUTSIDE_OFFSET_PX} textAnchor="middle" fill={labelFill} fontSize={fontSize} fontFamily="NanumSquare">{n.toLocaleString()}</text>
        </g>
    );
}
